
import { lang } from "moment";
import tippy from 'tippy.js';

//import('../../template/pb-downloads.css');

const DownloadCategory = {
    processing: false,
    query: null,
    service: null,
    filterType: null,
    filter: null,
    language: null,
    year: null,
    sort: "`order` ASC, id DESC",
    limit: null,
    page: $('#downloads .list-container .productPagination').find('li.active').children('a').data('page') || 1,
    typeSelected: $('#downloads .pb-list').data('type'),
    init: () => {
        DownloadCategory.initTooltips();
        if (typeof query == 'undefined') {
            var urlParams = new URLSearchParams(window.location.search);
            var query = urlParams.get("q");
            // console.log(query);
        }

        DownloadCategory.query = query;

        if (typeof publicFilter != 'undefined') {
            DownloadCategory.publicFilter = publicFilter;
        } else {
            DownloadCategory.publicFilter = ['revenda', 'engenharia', 'portobelloShop', 'exportacao', 'porcelanateria'];
        }

        if (typeof language != 'undefined') {
            DownloadCategory.language = language;
        }

        if (typeof year != 'undefined') {
            DownloadCategory.year = year;
        }

        if (typeof filesLimit != 'undefined') {
            DownloadCategory.limit = filesLimit;
        } else {
            DownloadCategory.limit = $('.jsLimitMenu').find('input[type="checkbox"]:checked').val();
        }

        if (typeof searchParams != 'undefined') {
            // console.log(searchParams);
        }

        if (typeof filterType !== "undefined") {
            DownloadCategory.filterType = filterType;
        } else {
            DownloadCategory.getFilterType();
        }

        // console.log(DownloadCategory.filterType);

        $('body').off('click','#modal-download--contact button.close').on('click', '#modal-download--contact button.close', function () {
            $('#modal-download--contact').fadeOut();
        });

        //$('#Type--header').find('button').click();

        //$('.pb23-downloads--list .jsFile .jsDirectDownload')

        $('body').on('blur', '#downloads #search input[name="q"]', function (event) {
            var q = $(this).val();
            DownloadCategory.query = q;
            DownloadCategory.page = 1;
            // console.log(q);
            DownloadCategory.refreshResults();
        });

        $('body').on('click', '.pb23-downloads--list .jsFile .jsDirectDownload', function (event) {
            event.preventDefault();
            event.stopPropagation();
            const fileId = $(this).data('id');
            const link = $(this).data('link');
            const fileTitle = $(this).data('title');
            const urlHome = window.location.origin;

            if ($(this).data("restrict")) {
                $('#formContactDownloadCategory').attr('action', urlHome + link);
                $('#modal-download--contact input[name="retURL"]').val(urlHome + link);
                $('#modal-download--contact input[name="retURL"]').attr('data-id', fileId);
                $('#modal-download--contact input[name="fileID"]').attr('data-id', fileId);
                $('#modal-download--contact input[name="fileID"]').val(fileTitle);

                $('#modal-download--contact').fadeIn();

                $('input[name="email"]')
                    .off("change")
                    .on("change", function () {
                        validateDownloadCategoryForm();
                    });
                $('input[name="00N1I00000NfmUS"]')
                    .off("change")
                    .on("change", function () {
                        validateDownloadCategoryForm();
                    });
                $('input[name="name"]')
                    .off("change")
                    .on("change", function () {
                        var fullname = $(this).val();
                        var names = fullname.split(" ");
                        var firstname = names[0];
                        delete names[0];
                        var lastname = names.join(" ");
                        $('input[name="first_name"]').val(firstname);
                        $('input[name="last_name"]').val(lastname);
                        validateDownloadCategoryForm();
                    });

                function validateDownloadCategoryForm() {
                    if (
                        $('#modal-download--contact input[name="name"]').val() &&
                        $('#modal-download--contact input[name="email"]').val() &&
                        $('#modal-download--contact input[name="00N1I00000NfmUS"]:checked')
                            .length > 0
                    )
                        $(".jsSubmitContact").removeAttr("disabled");
                    else $(".jsSubmitContact").attr("disabled", true);
                }

                $("#formContactDownloadCategory").on("submit", function (e) {
                    // console.log('test');
                    e.preventDefault();
                    // TODO: Enviar contato
                    var contactPeriod = [];
                    $('#modal-download--contact input[name="contactPeriod"]:checked').each(
                        function () {
                            contactPeriod.push($(this).val());
                        }
                    );
                    var data = {
                        type: "download",
                        email: $('#modal-download--contact input[name="email"]').val(),
                        name: $('#modal-download--contact input[name="name"]').val(),
                        phone: $('#modal-download--contact input[name="phone"]').val(),
                        newsletter:
                            $('#modal-download--contact input[name="00N1I00000NfmUS"]:checked')
                                .length > 0
                                ? "yes"
                                : "no",
                        contactPeriod: contactPeriod,
                        product: link,
                    };
                    var fileUrl = $('#modal-download--contact input[name="retURL"]').val();
                    DownloadCategory.service.insertContact(data, {
                        success: function (result) {
                            if (parseInt(result) > 0) {
                                UtilUi.loadTemplate(
                                    "assets/modal-download--success.tpl",
                                    function (dataContact, tpl) {

                                        var contact = { name: "" };
                                        var html = tpl.fetch({
                                            firstLanguage: lang,
                                            urlImageServer: urlImageServer,
                                            pathPrefix: pathPrefix,
                                            contact: data,
                                            link: link,
                                        });
                                        $("body").append(html);
                                        openModal("#modal-download--success");
                                        $("#modal-download--success").show();

                                        window.dataLayer.push({
                                            event: "downloadFile",
                                            file: fileUrl,
                                        });
                                        //window.open(fileUrl);

                                        $('#modal-download--success .close').off('click').on('click', function () {
                                            closeModal("#modal-download--success");
                                            $("#modal-download--success").remove();
                                        });
                                        setTimeout(function () {
                                            // console.log(fileUrl);
                                            document.location.href = fileUrl;
                                            //$('#formContactDownloadCategory').submit();
                                            closeModal("#modal-download--contact");
                                            $("#modal-download--contact").remove();
                                        }, 250);
                                    }
                                );
                            }
                        },
                    });

                    Util.service("WSRdStation", true, {
                        exceptionHandler: alertInterface.showError,
                        reflectSuccess: function (rdstation) {
                            var dataRd = {
                                email: data.email,
                                name: data.name,
                                city: data.city,
                                state: data.state,
                                website: "/produtos/downloads",
                                personal_phone: data.phone,
                                cf_site_download_arquivo_nome: fileUrl,
                                cf_site_download_arquivo_titulo: fileTitle,
                                cf_site_download_de_arquivo_id: fileId,
                            };

                            rdstation.insertLead(
                                dataRd,
                                "Site Portobello " +
                                (portobelloShop ? "Shop" : "") +
                                " - Form DownloadCategory"
                            );
                        },
                        reflectError: function () {
                            alert(_t("Erro de conexão, verifique sua conexão com a internet."));
                            window.reload();
                        },
                    });

                    return false;
                });

            } else {
                document.location.href = link;
            }

            return false;
        });

        $("body").on("change", ".pb-list--order .nav-item .form-check-input", function (evt) {
            if (!DownloadCategory.processing) {
                const id = "#" + $(this).attr("id");
                $(".pb-list--order .nav-item .form-check-input:checked:not(" + id + ")").prop("checked", false);

                DownloadCategory.sort = $(id).val();

                DownloadCategory.refreshResults();
            }

            return true;
        });

        $("#downloads #Type input[type='checkbox']").on('change', function (ev) {
            // console.log('input');
            if (!DownloadCategory.processing) {
                let filterType = [];

                $("#downloads #Type input[type='checkbox']").toArray().forEach(elem => {
                    if ($(elem).is(':checked')) {
                        let splitedId = $(elem).attr('id').split('_');

                        filterType.push(splitedId[2]);
                    }
                })

                DownloadCategory.filterType = filterType;
                DownloadCategory.refreshResults();
            }
            return false;
        });

        $("#downloads #Public input[type='checkbox']").on('change', function (ev) {
            // console.log('input');
            if (!DownloadCategory.processing) {
                let filter = [];

                $("#downloads #Public input[type='checkbox']").toArray().forEach(elem => {
                    if ($(elem).is(':checked')) {
                        let splitedId = $(elem).attr('id').split('_');

                        filter.push(splitedId[2]);
                    }
                })

                DownloadCategory.filter = filter;
                DownloadCategory.refreshResults();
            }
            return false;
        });

        $("#downloads #Year input[type='checkbox']").on('change', function (ev) {
            // console.log('input');
            if (!DownloadCategory.processing) {
                let filter = [];

                $("#downloads #Year input[type='checkbox']").toArray().forEach(elem => {
                    if ($(elem).is(':checked')) {
                        let splitedId = $(elem).attr('id').split('_');

                        filter.push(splitedId[2]);
                    }
                })

                DownloadCategory.year = filter;
                DownloadCategory.refreshResults();
            }
            return false;
        });

        $("#downloads #Language input[type='checkbox']").on('change', function (ev) {
            // console.log('input');
            if (!DownloadCategory.processing) {
                let filter = [];

                $("#downloads #Language input[type='checkbox']").toArray().forEach(elem => {
                    if ($(elem).is(':checked')) {
                        let splitedId = $(elem).data('id');

                        filter.push(splitedId);
                    }
                })

                DownloadCategory.language = filter;
                DownloadCategory.refreshResults();
            }
            return false;
        });


        $('body').on('click', '#downloads .list-container .productPagination a', function (ev) {
            ev.preventDefault();
            ev.stopImmediatePropagation();
            ev.stopPropagation();

            let page = $(this).data('page');

            if (!$(this).parent('li').hasClass('active')) {
                if ($(this).hasClass('nextPage')) {
                    DownloadCategory.page = page + 1;
                } else if ($(this).parent('li').hasClass('previous-page')) {
                    DownloadCategory.page = page - 1;
                } else {
                    DownloadCategory.page = page;
                }

                DownloadCategory.refreshResults();
            }

            return false;
        });


        $("body").on("click", ".add-cart", function addToCart(evt) {
            evt.stopPropagation();
            evt.preventDefault();

            /*const cartTemplate = "assets/components/pb-list--download/pb-list--cart.tpl";*/
            const cartTemplate = "assets/components-new/pb23-downloads--cart/pb23-downloads--cart.tpl";

            if ($(this).hasClass('url'))
            {
                const urlItem = $(this).data("item");
                const typeFile = $(this).data("type");
                const nameFile = $(this).data("name");
                
                DownloadCategory.service.addUrlToCart(typeFile, nameFile, urlItem, {
                    success: (cartItems) => {
                        UtilUi.loadTemplate(cartTemplate, (dataOn, tpl) => {
                            const html = tpl.fetch({ cartItems, urlImageServer,pathPrefix: pathPrefix, urlHome: urlhome });
                            $(".pb23-downloads--cart").replaceWith(html);
                        });
                    },
                });
                
            }
            else
            {
                const idItem = $(this).data("item");

                DownloadCategory.service.addItemToCart(idItem, {
                    success: (cartItems) => {
                        UtilUi.loadTemplate(cartTemplate, (dataOn, tpl) => {
                            const html = tpl.fetch({ cartItems, urlImageServer,pathPrefix: pathPrefix, urlHome: urlhome });
                            $(".pb23-downloads--cart").replaceWith(html);
                        });
                    },
                });
            }
            return false;
        });

        $("body").on("click", ".jsToggleCart", function toggleCart(evt) {
            evt.preventDefault();

            const cart = $(".pb23-downloads--cart");

            if (!cart.hasClass("closed")) {
                cart.addClass("closed");
                $('.jsTooltip').show();
            } else {
                cart.removeClass("closed");
                $('.jsTooltip').hide();
            }
            DownloadCategory.initTooltips();
        });

        $("body").on("submit", ".jsDownloadSearchForm[data-submit='false']", function (e) {
            e.preventDefault();
            e.stopPropagation();
            // console.log('form submited');
            var q = $(this).find('input[name="q"]').val();
            // console.log(q);
            if (q.length == 0) {
                return false;
            } else {
                $('.jsDownloadSearchForm').removeAttr('data-submit');
                $('.jsDownloadSearchForm').trigger('submit');
            }
        });

        $("body").on("change", ".jsFilterDownload input[type='radio']", function (e) {
            e.preventDefault();

            DownloadCategory.page = 1;

            var selector = $(this);
            var field = selector.attr('name');
            var fieldValue = selector.val();
            // console.log(`${field} changed to ${fieldValue}`);

            var fieldLabel = selector.closest('label').find('span').text();
            selector.parents('.jsFilterDownload').find('.jsToggleCategoriesMenu span').text(fieldLabel);

            if (
                selector.hasClass('jsCategoryAll')
                || selector.hasClass('jsRedirect')
            ) {
                return false;
            }

            switch (field) {
                case 'order':
                    switch (fieldValue) {
                        case 'atoz':
                            DownloadCategory.sort = "i.content ASC, f.id DESC";
                            break;
                        case 'ztoa':
                            DownloadCategory.sort = "i.content DESC, f.id DESC";
                            break;
                        case 'newest':
                            DownloadCategory.sort = "f.dateUpdated DESC, f.dateCreated DESC, f.id DESC";
                            break;
                        default:
                            DownloadCategory.sort = "f.`order` ASC, f.id DESC";
                            break;
                    }
                    break;

                case 'filesLimit':
                    DownloadCategory.limit = fieldValue;
                    break;

                case 'pt':
                    if (fieldValue == "" || fieldValue == null) {
                        DownloadCategory.productType = null;
                    } else {
                        DownloadCategory.productType = fieldValue;
                    }
                    break;
            };


            DownloadCategory.refreshResults();
        });

        $("body").on("click", "#jsDownloadSearchCart", function downloadCart(evt) {
            evt.preventDefault();

            $('.pb23-downloads--cart .jsCartBody').hide();
            $('.pb23-downloads--cart .jsCartFooter').hide();
            $('.pb23-downloads--cart .jsProgress').show();

            UtilUi.alert({ title: 'Erro no download!', message: 'O arquivo não pode ser gerado, tente novamente mais tarde!' }, 'warning');

            DownloadCategory.service.downloadCart({
                success: (result) => {
                    if (result) {
                        window.location.href = result;
                    } else {
                        $('.pb23-downloads--cart .jsCartBody').show();
                        $('.pb23-downloads--cart .jsCartFooter').show();
                        $('.pb23-downloads--cart .jsProgress').hide();

                        UtilUi.alert({ title: 'Erro no download!', message: 'O arquivo não pode ser gerado, tente novamente mais tarde!' }, 'warning');
                    }
                },
            });
        });

        $("body").on("change", ".jsFilterDownload input[type='checkbox']", function (e) {
            e.preventDefault();

            var checkedCheckboxes = [];

            var multipleText = []
            $(".jsFilterDownload input[type='checkbox']:checked").each(function () {
                var selector = $(this);
                var field = $(this).attr('name');
                var matches = field.match(/\[([^\]]+)\]/g);

                if (matches && matches.length > 0) {
                    var lastValue = matches[matches.length - 1].replace(/\[|\]/g, ''); // Remove os colchetes
                    checkedCheckboxes.push(lastValue);
                    multipleText.push(selector.parents('label').find('span').text());
                }

            });

            $('.jsRedirect').prop('checked', false);
            if (checkedCheckboxes.length > 0) {
                $('.jsCategoryAll').prop('checked', false);
            } else {
                $('.jsCategoryAll').prop('checked', true);
            }


            if (checkedCheckboxes.length > 1) {
                // $('.jsToggleCategoriesMenu').find('span').text('Múltiplos');
                $('.jsToggleCategoriesMenu').find('span').text(multipleText.join(', '));
            } else if (checkedCheckboxes.length > 0) {
                $('.jsCategoryAll').prop('checked', false);
                var text = $('.jsCategoriesMenu').find('input:checked').parents('label').find('span').text();
                $('.jsToggleCategoriesMenu').find('span').text(text);
            } else {
                $('.jsCategoryAll').prop('checked', true);
                var text = $('.jsCategoriesMenu').find('input:checked').parents('label').find('span').text();
                $('.jsToggleCategoriesMenu').find('span').text(text);
            }
            DownloadCategory.filterType = checkedCheckboxes;
            // DownloadCategory.refreshResults();
        });


        $("body").on("change", ".jsFilterDownload .jsCategoryAll", function (e) {
            e.preventDefault();
            e.stopPropagation();

            var element = $(this);

            if (element.is(":checked")) {
                element.parents('.jsFilterDownload').find('.jsCategory').prop('checked', false);
            }

            DownloadCategory.filterType = ['folder', 'catalogo', 'manual', 'livro', 'relatorio', 'jornal', /*'link',  'sketchup', */ 'apostila', 'video', 'podcast', 'outros', /* 'autocad', 'certificado', */ 'trendbook'];
        });

        $("body").on("change", ".jsFilterDownload .jsRedirect", function (e) {
            e.preventDefault();
            e.stopPropagation();

            var element = $(this);

            if (element.is(":checked")) {
                element.parents('.jsFilterDownload').find('.jsCategory').prop('checked', false);
                var text = element.parents('label').find('span').text();
                $('.jsToggleCategoriesMenu').find('span').text(text);
                // return false;
                window.location.href = element.data('url');
            }

        });

        $("body").on("click", ".jsApplyFilters", function (e) {
            e.preventDefault();
            e.stopPropagation();

            var redirect = false;
            $(".jsFilterDownload .jsRedirect").each(function (e) {
                var radioElement = $(this);
                if (radioElement.is(":checked")) {
                    radioElement.parents('.jsFilterDownload').find('.jsCategory').prop('checked', false);
                    var text = radioElement.parents('label').find('span').text();
                    $('.jsToggleCategoriesMenu').find('span').text(text);
                    redirect = radioElement.data('url');
                }
            })

            if (redirect) {
                window.location.href = redirect;
            } else {
                DownloadCategory.refreshResults();
            }

            $('.jsCategoriesMenu').hide();
        });

        $("body").on("click", ".jsClearFilters", function (e) {
            e.preventDefault();
            e.stopPropagation();

            $(".jsFilterDownload input[type='checkbox']").each(function () {
                $(this).prop('checked', true).trigger('change');
            });

            /* $('.jsCategoryAll').prop('checked', true);
            var text = $('.jsCategoryAll').parents('label').find('span').text();
            $('.jsToggleCategoriesMenu').find('span').text(text); */

            DownloadCategory.filterType = ['folder', 'catalogo', 'manual', 'livro', 'relatorio', 'jornal', /*'link',  'sketchup', */ 'apostila', 'video', 'podcast', 'outros', /* 'autocad', 'certificado', */ 'trendbook'];
            // DownloadCategory.refreshResults();
            // $('.jsCategoriesMenu').hide();
        });

        $("body").on("click", "#jsClearCart", function cleanCart(evt) {
            evt.preventDefault();

            const cartTemplate = "assets/components-new/pb23-downloads--cart/pb23-downloads--cart.tpl";

            DownloadCategory.service.cleanCart({
                success: (cartItems) => {
                    UtilUi.loadTemplate(cartTemplate, (dataOn, tpl) => {
                        const html = tpl.fetch({ cartItems, urlImageServer, pathPrefix: pathPrefix, urlHome: urlhome });
                        $(".pb23-downloads--cart").replaceWith(html);
                        DownloadCategory.initTooltips();
                    });
                },
            });
        });

        $("body").on("click", "#jsDownloadCategoryCart", function downloadCart(evt) {
            evt.preventDefault();

            $('.pb23-downloads--cart .jsCartBody').hide();
            $('.pb23-downloads--cart .jsCartFooter').hide();
            $('.pb23-downloads--cart .jsProgress').show();

            UtilUi.alert({ title: 'Erro no download!', message: 'O arquivo não pode ser gerado, tente novamente mais tarde!' }, 'warning');

            DownloadCategory.service.downloadCart({
                success: (result) => {
                    if (result) {
                        window.location.href = result;
                    } else {
                        $('.pb23-downloads--cart .jsCartBody').show();
                        $('.pb23-downloads--cart .jsCartFooter').show();
                        $('.pb23-downloads--cart .jsProgress').hide();

                        UtilUi.alert({ title: 'Erro no download!', message: 'O arquivo não pode ser gerado, tente novamente mais tarde!' }, 'warning');
                    }
                },
            });
        });

        $("body").on("click", "#jsRemoveItem", function removeItem(evt) {
            evt.preventDefault();

            const idItem = $(this).data("item");
            const cartTemplate = "assets/components-new/pb23-downloads--cart/pb23-downloads--cart.tpl";

            DownloadCategory.service.removeItemFromCart(idItem, {
                success: (cartItems) => {
                    UtilUi.loadTemplate(cartTemplate, (dataOn, tpl) => {
                        const html = tpl.fetch({ cartItems, urlImageServer, pathPrefix: pathPrefix, urlHome: urlhome });
                        $(".pb23-downloads--cart").replaceWith(html);
                    });
                },
            });
        });


        /* $("body").on("change", ".jsChangeSalesChannel", (e) => {
          e.preventDefault();
          e.stopPropagation();
          var salesChannelValue = $('.jsChangeSalesChannel:checked').val();
          $('.pb23-downloads--search .jsSalesChannel').val(salesChannelValue);
          $('.pb23-downloads--search .jsSalesChannel').parents('form').trigger('submit');
          return false;
        }); */

        $("body").on("change", ".jsChangeSalesChannel", (e) => {
            e.preventDefault();
            e.stopPropagation();

            var salesChannelValue = $('.jsChangeSalesChannel:checked').val();

            var currentURL = window.location.href;
            var newURL = currentURL.split("?")[0] + "?public=" + salesChannelValue;

            window.location.href = newURL;
            return false;
        });


        $("body").on("click", ".jsToggleSalesChannelMenu", (e) => {
            e.preventDefault();
            e.stopPropagation();
            var salesChannelElement = $('.jsSalesChannelMenu');
            if (salesChannelElement.is(':visible')) {
                salesChannelElement.hide();
            } else {
                salesChannelElement.show();
            }
            return false;
        });

        $("body").on("click", ".jsToggleCategoriesMenu", (e) => {
            e.preventDefault();
            e.stopPropagation();
            var categoriesElement = $('.jsCategoriesMenu');
            if (categoriesElement.is(':visible')) {
                categoriesElement.hide();
            } else {
                categoriesElement.show();
            }
            return false;
        });

        $("body").on("click", ".jsToggleFilter", function (e) {
            e.preventDefault();
            e.stopPropagation();
            var toggleElement = $(this).parents('.jsFilter').find('.jsToggleable');

            if (toggleElement.is(':visible')) {
                toggleElement.hide();
            } else {
                $('.jsToggleable').hide();
                toggleElement.show();
            }

            return false;
        });

        $("body").on("click", ".jsLoadMore", function (e) {
            e.preventDefault();
            e.stopPropagation();

            var loading = $(this).attr('data-loading');

            if (loading == true || loading == "true") {
                UtilUi.alert({
                    title: "Aguarde",
                    message: "Carregando dados"
                }, 'warning');
                return false;
            }

            $(this).attr('data-loading', 'true');
            DownloadCategory.loadMore();

            return false;
        });


        $("body").on("click", (e) => {
            var categoriesMenu = $(".jsCategoriesMenu");
            if (categoriesMenu.is(":visible") && !categoriesMenu.is(e.target) && categoriesMenu.has(e.target).length === 0) {
                categoriesMenu.hide();
            }

            var channelsMenu = $(".jsSalesChannelMenu");
            if (channelsMenu.is(":visible") && !channelsMenu.is(e.target) && channelsMenu.has(e.target).length === 0) {
                channelsMenu.hide();
            }
        });

        $('body').on('click', '.pb23-downloads--list-filter .jsTriggerFilter', function (e) {
            e.preventDefault();
            e.stopPropagation();

            var elem = $(this);
            var type = elem.data('type');
            elem.parents('.jsFilterComponent').attr('data-expanded', 'true').attr('data-type', type);

            return false;
        });

        $('body').on('click', '.pb23-downloads--list-filter .jsCancelMobileFilters, .pb23-downloads--list-filter .jsApplyMobileFilters', function (e) {
            e.preventDefault();
            e.stopPropagation();

            var elem = $(this);
            var type = elem.data('type');
            elem.parents('.jsFilterComponent').attr('data-expanded', 'false');

            return false;
        });


    },

    initTooltips: () => {
        tippy.setDefaultProps({ delay: 0 });
        $(".jsTooltip").each(function () {
            var button = $(this);
            var text = button.attr('data-title');
            // var id = button.attr('id');
            tippy(button[0], {
                content: text,
                theme: 'light',
                arrow: true,
                arrow: tippy.roundArrow,
                // animation: 'fade',
                sticky: true,
                placement: 'top-end',
                appendTo: $('section#downloads')[0],

            });

        })
    },
    refreshResults: () => {
        $('.jsToggleable').hide();
        $('.pb23-downloads--list.jsListContainer').attr('data-loading', 'true');
        DownloadCategory.processing = true;

        if (!isNaN(DownloadCategory.limit) && DownloadCategory.limit != null && DownloadCategory.limit != "") {
            var offset = DownloadCategory.page * DownloadCategory.limit - DownloadCategory.limit;
            if (offset < 0) {
                offset = 0;
            }

            var options = {
                1: DownloadCategory.sort,
                2: DownloadCategory.limit,
                3: offset,
            };

            if (offset == 0) {
                delete options[3];
            }
        } else {
            var options = {
                1: DownloadCategory.sort,
            };
        }

        if (DownloadCategory.typeSelected == "") {
            DownloadCategory.typeSelected = null;
        }

        $("#downloads .list-container").scheletrone();
        // console.log(DownloadCategory.sort);
        DownloadCategory.service.getFiles(
            DownloadCategory.filterType,
            DownloadCategory.publicFilter,
            options,
            DownloadCategory.productType,
            'y',
            DownloadCategory.year,
            DownloadCategory.language,
            {
                success: data => {
                    DownloadCategory.renderFiles(data);
                }
            }
        );

        DownloadCategory.updateUrl()
    },
    renderFiles: (data, loadMore = false) => {
        // console.log(data);
        DownloadCategory.service.countFiles(
            DownloadCategory.filterType,
            DownloadCategory.publicFilter,
            DownloadCategory.productType,
            'y',
            DownloadCategory.year,
            DownloadCategory.language,
            {
                success: (filesTotal) => {
                    DownloadCategory.displayTotal(filesTotal, data, loadMore);
                }
            }
        );
    },
    displayTotal: function (filesTotal, data, loadMore = false) {
        $("#downloads .list-container").scheletrone('stopLoader');
        // $('html, body').animate({scrollTop: 0}, 400);

        let filesLimit = filesTotal / DownloadCategory.limit;


        if (Number.isInteger(filesLimit)) {
            //
        } else {
            filesLimit = Math.ceil(filesLimit);
        }

        UtilUi.alert({
            title: "Processando",
            message: "Aguarde um momento enquanto buscamos os resultados"
        }, 'warning');
        UtilUi.loadTemplate("assets/components-new/pb23-downloads--list/pb23-downloads--list-item.tpl", function (dataOn, tpl) {
            DownloadCategory.processing = false;

            var formatedData = DownloadCategory.formatDownloadData(data);
            // console.log(formatedData);

            var htmlContent = tpl.fetch({
                items: formatedData,
                pathPrefix: pathPrefix,
                conversion: true
            });

            var loadMoreButton = $('.pb23-downloads--list .jsLoadMore');

            if (loadMore) {
                loadMoreButton.attr('data-loading', 'false');
                $("section#downloads .pb23-downloads--list .jsDownloadList").append(htmlContent);
            } else {
                $("section#downloads .pb23-downloads--list .jsDownloadList").html(htmlContent);
            }

            var loadedFiles = $('.pb23-downloads--list .jsFile').length;
            if (loadedFiles >= filesTotal) {
                loadMoreButton.hide();
            } else {
                loadMoreButton.show();
            }

            if (filesTotal == 0) {
                $('.pb23-downloads--list .jsError').show();
            } else {
                $('.pb23-downloads--list .jsError').hide();
            }

            $('.pb23-downloads--list.jsListContainer').attr('data-loading', 'false');
            UtilUi.alert({
                title: "Concluido",
                message: "Busca concluida"
            }, 'success');
        });
    },
    updateUrl: function () {
        var formData = $('.jsFilterDownload').serialize(); // Serializa o formulário em formato de consulta
        var currentURL = window.location.href;
        var currentSearch = window.location.search;
        var baseURL = currentURL.replace(currentSearch, '');
        var newUrl = baseURL + '?' + formData;
        window.history.replaceState({}, document.title, newUrl);
        return false;
        /*
         var queryString = "?searching=1";
         if (DownloadCategory.query)
         {
           queryString += '&q='+DownloadCategory.query;
         }
         if (DownloadCategory.page)
         {
           queryString += '&page='+DownloadCategory.page;
         }
         if (DownloadCategory.filterType)
         {
           queryString += '&type='+DownloadCategory.filterType;
         }
         if (DownloadCategory.language)
         {
           queryString += '&lang='+DownloadCategory.language;
         }
         if (DownloadCategory.year)
         {
           queryString += '&year[]='+DownloadCategory.year.join('&year[]=');
         }
         if (DownloadCategory.filter)
         {
           queryString += '&public[]='+DownloadCategory.publicFilter.join('&public[]=');
         }
         const originalUrl = location.protocol + "//" + location.host + location.pathname;
         window.history.pushState({ content: originalUrl}, "", originalUrl + queryString);
         */
    },
    getFilterType: () => {
        if (typeFilter) {
            DownloadCategory.filterType = typeFilter;
        } else {
            var currentURL = window.location.href;
            var match = currentURL.match(/\/([^/]+)\/?$/);
            if (match) {
                var urlType = match[1];
                var urlTypeQs = urlType.split('?');
                DownloadCategory.filterType = urlTypeQs[0];
            } else {
                DownloadCategory.filterType = null;
            }
        }

    },
    loadMore: () => {
        DownloadCategory.page++;
        DownloadCategory.processing = true;

        if (!isNaN(DownloadCategory.limit) && DownloadCategory.limit != null && DownloadCategory.limit != "") {
            var offset = DownloadCategory.page * DownloadCategory.limit - DownloadCategory.limit;
            if (offset < 0) {
                offset = 0;
            }

            var options = {
                1: DownloadCategory.sort,
                2: DownloadCategory.limit,
                3: offset,
            };

            if (offset == 0) {
                delete options[3];
            }
        } else {
            var options = {
                1: DownloadCategory.sort,
            };
        }

        if (DownloadCategory.typeSelected == "") {
            DownloadCategory.typeSelected = null;
        }

        $("#downloads .list-container").scheletrone();
        DownloadCategory.service.getFiles(
            DownloadCategory.filterType,
            DownloadCategory.publicFilter,
            options,
            DownloadCategory.productType,
            'y',
            DownloadCategory.year,
            DownloadCategory.language,
            {
                success: data => {
                    DownloadCategory.renderFiles(data, true);
                }
            }
        );
        DownloadCategory.updateUrl()
    },
    formatDownloadData: data => {

        var types = {
            'catalogo': 'Catálogos',
            'folder': 'Folders',
            'certificado_fotos': 'Fotos de produtos',
            'certificado_laudos': 'Laudos técnicos',
            'manual': 'Manuais',
            'sketchup': 'Blocos 3D',
            'relatorio': 'Relatórios',
            'livro': 'Livros',
            'jornal': 'Jornais',
            'link': 'Links',
            'apostila': 'Apostilas',
            'video': 'Vídeos',
            'podcast': 'Podcasts',
            'outros': 'Outros',
            'autocad': 'Autocad',
            'trendbook': 'Trendbooks'
        };

        var newData = []
        data.forEach(function (item) {
            item.convType = types[item.type];
            item.convSize = (parseFloat(item.fileSize) / 1048576).toFixed(2);

            if (item.dateUpdated != null && item.dateUpdated != "") {
                item.convDate = DownloadCategory.parseToDate(item.dateUpdated);
            } else {
                item.convDate = DownloadCategory.parseToDate(item.dateCreated);
            }

            newData.push(item);
        });

        return newData;

    },
    parseToDate: stringDate => {
        if (typeof stringDate !== 'object') {
            var partials = stringDate.split(/[- :]/);

            var objectDate = new Date(
                parseInt(partials[0], 10),
                parseInt(partials[1], 10) - 1,
                parseInt(partials[2], 10),
                parseInt(partials[3], 10),
                parseInt(partials[4], 10),
                parseInt(partials[5], 10)
            );

            if (isNaN(objectDate.getTime())) {
                return null;
            }

            // Formatar a data no padrão "d/m/Y"
            var day = objectDate.getDate().toString().padStart(2, '0');
            var month = (objectDate.getMonth() + 1).toString().padStart(2, '0');
            var year = objectDate.getFullYear();

            var formattedDate = day + '/' + month + '/' + year;
            return formattedDate;
        } else if (stringDate instanceof Date) {
            // Formatar a data no padrão "d/m/Y"
            var day = stringDate.getDate().toString().padStart(2, '0');
            var month = (stringDate.getMonth() + 1).toString().padStart(2, '0');
            var year = stringDate.getFullYear();

            var formattedDate = day + '/' + month + '/' + year;
            return formattedDate;
        } else {
            return null;
        }
    },
    initService: () => {
        Util.service("WSPortobelloSite", true, {
            exceptionHandler: alertInterface.showError,
            reflectSuccess: function (service) {
                DownloadCategory.service = service;
                DownloadCategory.init();
            },
            reflectError: function () {
                alert(_t("Erro de conexão, verifique sua conexão com a internet."));
                window.reload();
            },
        });
    }


}

function openModal(target) {
    var target = target;

    $(target).addClass("show");
    $(target).css("display", "show");
    $("body").addClass("noScroll");
    return false;
}

export default () => {
    DownloadCategory.initService();
};

